import './footer.css';
import React, { useState, useEffect } from 'react';
import { TfiEmail } from "react-icons/tfi";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import ConsultaModal from './4.1-ConsultaModal/index';
import Logo from '../../Assets/images/Logos/Nav-Logo.avif';

const Footer = () => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const onOpenConsulta = () => setModalOpen(true);
    window.addEventListener('masini:openConsulta', onOpenConsulta);
    return () => window.removeEventListener('masini:openConsulta', onOpenConsulta);
  }, []);

  const mail = "masiniasociados@gmail.com";
  const subject = "Consulta desde Masini Asociados Web";
  const body = "";
  const mailtoLink = `mailto:${mail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className='Footer-Component'>
      {/* CTA (bloque azul del mockup) */}
      <section className="Footer-CTA" id="cta">
        <div className="Footer-CTA-inner">
          <div className="Footer-CTA-copy">
            <p>Estudio Jurídico · Buenos Aires</p>
            <h2>Conocer tus derechos es el primer paso para una defensa exitosa.</h2>
            <p className="Footer-CTA-strong">
              Contactanos ahora mismo para recibir respaldo legal personalizado.
            </p>
          </div>
          <button
            type="button"
            className="Footer-CTA-btn"
            onClick={() => setModalOpen(true)}
          >
            Contactanos ahora
          </button>
        </div>
      </section>

      {/* Footer oscuro (como el HTML) */}
      <section className="Footer-Main">
        <div className="Footer-Main-inner">
          <div className="Footer-Brand">
            <img
              className="Footer-Logo"
              src={Logo}
              alt="Masini Asociados"
              loading="lazy"
              decoding="async"
              onClick={scrollToTop}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  scrollToTop();
                }
              }}
              role="button"
              tabIndex={0}
            />
          </div>

          <div className="Footer-Data">
            <div className="Footer-Item">
              <FaLocationDot size={16} />
              <span>Ciudad Autónoma de Buenos Aires</span>
            </div>
            <a className="Footer-Item Footer-Link" href={mailtoLink} target="_blank" rel="noopener noreferrer">
              <TfiEmail size={16} />
              <span>masiniasociados@gmail.com</span>
            </a>
            <div className="Footer-Item">
              <FaPhone size={16} />
              <span>+54 9 11 6193 7832</span>
            </div>
          </div>
        </div>

        <div className="foot-bottom">
          <span>© 2025 Masini Asociados. Todos los derechos reservados.</span>
          <div className="foot-credits">
            <span className="foot-credit">
              Designed by{' '}
              <a
                href="https://www.fosforodigital.com.ar"
                className="foot-credit-fosforo"
                aria-label="Ir a Fósforo Digital"
                target="_blank"
                rel="noopener noreferrer"
              >
                FOSFORO
              </a>
            </span>
            <span className="foot-credit">
              Developed by{' '}
              <a
                href="https://www.franciscoandrade.com.ar"
                className="foot-credit-dev"
                aria-label="Ir a Francisco Andrade"
                target="_blank"
                rel="noopener noreferrer"
              >
                Fran Andrade
              </a>
            </span>
          </div>
        </div>
      </section>

      <ConsultaModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </footer>
  );
};

export default Footer;
